import { connect } from 'react-redux';
import { mapPlotMetadataAndDispatchToGeneratorSelectedHandler } from 'js/containers/legacy/GraphSection';
import SelectedGeneratorsCheckbox from 'js/components/legacy/SelectedGeneratorsCheckbox';
export default connect(function (state, ownProps) {
  return {
    checkboxId: "".concat(ownProps.plotId, "-").concat(state.graphGeneratorData[ownProps.plotId][ownProps.generatorId].id, "-checkbox"),
    checkboxChecked: state.graphGeneratorData[ownProps.plotId][ownProps.generatorId].selected,
    checkboxTitle: state.graphGeneratorData[ownProps.plotId][ownProps.generatorId].title,
    checkboxColor: state.graphGeneratorData[ownProps.plotId][ownProps.generatorId].color
  };
}, function (dispatch, ownProps) {
  return {
    plotGeneratorSelected: mapPlotMetadataAndDispatchToGeneratorSelectedHandler(ownProps.plotId, dispatch)
  };
})(SelectedGeneratorsCheckbox);